/**
 * The size a visualizer draws at: the size it is given, else the size its
 * container measured. The timeline passes the item's box, which changes when
 * a template is applied while the component stays mounted, so a measurement
 * taken at mount would keep drawing the old box. v1's layouts pass no size
 * and size the container with classes, so they still measure.
 */
export function drawSize(
  given: { width?: number | undefined; height?: number | undefined },
  measured: { width?: number | undefined; height?: number | undefined },
) {
  return {
    width: given.width ?? measured.width,
    height: given.height ?? measured.height,
  }
}
